import React, { createContext, useState, useEffect, useCallback, useContext } from 'react';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { debounce } from 'lodash';

// 1. Create the context
const SearchContext = createContext();

// 2. Create the provider component
export const SearchProvider = ({ children }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [results, setResults] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isSearchVisible, setIsSearchVisible] = useState(false);

  const functions = getFunctions();
  const searchAppContent = httpsCallable(functions, 'searchAppContent');

  const performSearch = useCallback(
    debounce(async (term) => {
      if (term.length < 2) {
        setResults([]);
        setIsLoading(false);
        return;
      }
      setIsLoading(true);
      try {
        const response = await searchAppContent({ searchTerm: term });
        setResults(response.data.results || []);
      } catch (error) {
        console.error("Search failed:", error);
      } finally {
        setIsLoading(false);
      }
    }, 500),
    []
  );

  useEffect(() => {
    // Hide results if search term is cleared
    if (!searchTerm) {
        setResults([]);
        setIsLoading(false);
    } else {
        performSearch(searchTerm);
    }
  }, [searchTerm, performSearch]);

  const clearSearch = () => {
    setSearchTerm('');
    setResults([]);
    setIsSearchVisible(false); // ✅ This is the missing line
  };

  const value = {
    searchTerm,
    setSearchTerm,
    results,
    isLoading,
    isSearchVisible,
    setIsSearchVisible,
    clearSearch,
  };

  return <SearchContext.Provider value={value}>{children}</SearchContext.Provider>;
};

// 3. Create a custom hook for easy access
export const useSearch = () => useContext(SearchContext);